var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "formdata", attrs: { model: _vm.formdata, rules: _vm.rules } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.name"),
                prop: "advertisingSpaceName",
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c("el-input", {
                staticStyle: { width: "600px" },
                attrs: {
                  placeholder: _vm.$i18n.t("common.Pleaseenteraname"),
                  "show-word-limit": "",
                  maxlength: "100"
                },
                model: {
                  value: _vm.formdata.advertisingSpaceName,
                  callback: function($$v) {
                    _vm.$set(_vm.formdata, "advertisingSpaceName", $$v)
                  },
                  expression: "formdata.advertisingSpaceName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.country"),
                prop: "countryCode",
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  staticStyle: { width: "180px" },
                  attrs: {
                    clearable: "",
                    placeholder: _vm.$i18n.t("common.country")
                  },
                  model: {
                    value: _vm.formdata.countryCode,
                    callback: function($$v) {
                      _vm.$set(_vm.formdata, "countryCode", $$v)
                    },
                    expression: "formdata.countryCode"
                  }
                },
                _vm._l(_vm.dictionary.country, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.time"),
                prop: "time",
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: "",
                  type: "datetimerange",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm:ss",
                  "range-separator": "-",
                  "start-placeholder": _vm.$i18n.t("common.starttime"),
                  "end-placeholder": _vm.$i18n.t("common.Endtime"),
                  "default-time": ["00:00:00", "23:59:59"]
                },
                model: {
                  value: _vm.formdata.time,
                  callback: function($$v) {
                    _vm.$set(_vm.formdata, "time", $$v)
                  },
                  expression: "formdata.time"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.picture"),
                "label-width": _vm.formLabelWidth,
                required: true
              }
            },
            [
              _c("imgUpload", {
                ref: "imageUpload",
                attrs: { img: _vm.formdata.imgUrl },
                on: { event: _vm.changeUrl }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.InputLink"),
                "label-width": _vm.formLabelWidth,
                required: true
              }
            },
            _vm._l(_vm.formdata.advertisingSpaceLinkList, function(
              item,
              index
            ) {
              return _c(
                "div",
                {
                  key: index,
                  staticStyle: { display: "flex", "margin-bottom": "10px" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "600px" },
                    attrs: {
                      placeholder: _vm.$i18n.t("common.Enterjumplink"),
                      "show-word-limit": "",
                      maxlength: "255"
                    },
                    model: {
                      value: item.linkUrl,
                      callback: function($$v) {
                        _vm.$set(item, "linkUrl", $$v)
                      },
                      expression: "item.linkUrl"
                    }
                  }),
                  _vm.formdata.advertisingSpaceLinkList.length < 10
                    ? _c("span", [
                        _c("i", {
                          staticClass: "el-icon-circle-plus-outline",
                          staticStyle: { "font-size": "22px" },
                          on: {
                            click: function($event) {
                              return _vm.addLinks(item)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.formdata.advertisingSpaceLinkList.length > 1
                    ? _c("span", [
                        _c("i", {
                          staticClass: "el-icon-remove-outline",
                          staticStyle: { "font-size": "20px" },
                          on: {
                            click: function($event) {
                              return _vm.delLinks(item, index)
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ],
                1
              )
            }),
            0
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.Enableornot"),
                prop: "status",
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c("el-switch", {
                attrs: {
                  "active-color": "#13ce66",
                  "active-value": 1,
                  "inactive-value": 0
                },
                model: {
                  value: _vm.formdata.status,
                  callback: function($$v) {
                    _vm.$set(_vm.formdata, "status", $$v)
                  },
                  expression: "formdata.status"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.Applicableclassification"),
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  props: _vm.classifyTreeProps,
                  data: _vm.classifyTreeDict,
                  "node-key": "goodsClassifyId",
                  "default-checked-keys": _vm.checkedKeys,
                  "show-checkbox": ""
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$i18n.t("common.Applicableproducts"),
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.changeGoods } },
                [_vm._v(_vm._s(_vm.$i18n.t("common.Addproduct")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { "label-width": _vm.formLabelWidth } },
            [
              _c(
                "el-table",
                {
                  ref: "goodsSelectList",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.goodsSelectList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodsId",
                      label: _vm.$i18n.t("common.ProductID1"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodsCode",
                      label: _vm.$i18n.t("common.SKU_EAN_Encoding"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v("SKU:" + _vm._s(scope.row.sku))
                            ]),
                            _c("br"),
                            _c("span", [
                              _vm._v("EAN:" + _vm._s(scope.row.barCode))
                            ]),
                            _c("br"),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$i18n.t("common.coding")) +
                                  ":" +
                                  _vm._s(scope.row.goodsCode)
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "imageUrl",
                      label: _vm.$i18n.t("common.Productimage1"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.imageUrl
                              ? _c("el-image", {
                                  staticStyle: { height: "100px" },
                                  attrs: {
                                    src: _vm.ossHost + scope.row.imageUrl,
                                    fit: "fill"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: _vm.$i18n.t("common.ProductName"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodsSpecials",
                      label: _vm.$i18n.t("common.Countrieslisted"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return _vm._l(scope.row.goodsSpecials, function(
                            s,
                            index
                          ) {
                            return _c("span", { key: index }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$dict.getDictValue(
                                      "countrys",
                                      s.countryCode
                                    )
                                  )
                              ),
                              _c("br")
                            ])
                          })
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "prices",
                      label: _vm.$i18n.t("common.Promotionprice1"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.isShowGoodsPromotion(
                              scope.row.promotionRuleCountrys,
                              "NEW"
                            )
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "text-align": "left",
                                          display: "block"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$i18n.t(
                                              "common.NewUserPromotion"
                                            )
                                          )
                                        ),
                                        _c("br")
                                      ]
                                    ),
                                    _vm._l(
                                      scope.row.promotionRuleCountrys,
                                      function(promotion, index) {
                                        return promotion.userType == "NEW"
                                          ? _c("span", { key: index }, [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$dict.getDictValue(
                                                      "countrys",
                                                      promotion.countryCode
                                                    )
                                                  ) +
                                                  ":" +
                                                  _vm._s(
                                                    _vm.getPromotionGoodsPrice(
                                                      promotion,
                                                      scope.row.prices
                                                    )
                                                  )
                                              ),
                                              _c("br")
                                            ])
                                          : _vm._e()
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.isShowGoodsPromotion(
                              scope.row.promotionRuleCountrys,
                              "OLD"
                            )
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "text-align": "left",
                                          display: "block"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$i18n.t(
                                              "common.RegularUserPromotion"
                                            )
                                          )
                                        ),
                                        _c("br")
                                      ]
                                    ),
                                    _vm._l(
                                      scope.row.promotionRuleCountrys,
                                      function(promotion, index) {
                                        return promotion.userType == "OLD"
                                          ? _c("span", { key: index }, [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$dict.getDictValue(
                                                      "countrys",
                                                      promotion.countryCode
                                                    )
                                                  ) +
                                                  ":" +
                                                  _vm._s(
                                                    _vm.getPromotionGoodsPrice(
                                                      promotion,
                                                      scope.row.prices
                                                    )
                                                  )
                                              ),
                                              _c("br")
                                            ])
                                          : _vm._e()
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            !scope.row.promotionRuleCountrys ||
                            scope.row.promotionRuleCountrys.length == 0
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$i18n.t(
                                        "common.ThereAreCurrentlyNoProductPromotions"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brand",
                      label: _vm.$i18n.t("common.fixedprice"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return _vm._l(scope.row.prices, function(s, index) {
                            return _c("span", { key: index }, [
                              _vm._v(" " + _vm._s(s.resultPrice.toFixed(2))),
                              _c("br")
                            ])
                          })
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shelf",
                      label: _vm.$i18n.t("common.state"),
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.shelf == true
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#46a8a0" } },
                                  [_vm._v(_vm._s(_vm.$i18n.t("common.Listed")))]
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$i18n.t("common.Notlisted"))
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$i18n.t("common.operation"),
                      fixed: "right",
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-inner-button",
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteGoods(
                                      scope.$index,
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$i18n.t("common.delete")))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "20%" },
              on: {
                click: function($event) {
                  return _vm.closeDialog(false)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$i18n.t("common.cancel")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "20%" },
              attrs: { type: "primary", loading: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.onSubmit("formdata")
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$i18n.t("common.confirm")))]
          )
        ],
        1
      ),
      _vm.goodsDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: { visible: _vm.goodsDialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function($event) {
                  _vm.goodsDialogVisible = $event
                }
              }
            },
            [
              _c("goods-dialog", {
                ref: "goodsDialog",
                attrs: {
                  dictionary: _vm.dictionary,
                  goodsSelectList: _vm.goodsSelectList
                },
                on: { handleSelected: _vm.handleSelectionGooods }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }